<script>
  import { onMount } from "svelte";
  import * as THREE from "three";
  import gsap from "gsap";
  import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
  import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
  //import Checkout from "./checkout.svelte";

  let canvas;
  let camera;
  export let designImageData;
  export let goToCheckout;

  onMount(() => {
    console.log(canvas);
    //const canvas =

    const scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(
      75,
      canvas.width / canvas.height,
      0.1,
      1000
    );

    const renderer = new THREE.WebGLRenderer({
      canvas,
      alpha: true,
      antialias: true,
    });
    renderer.setSize(canvas.width, canvas.height);
    // const controls = new OrbitControls(camera, canvas);

    // const texture = new THREE.TextureLoader().load(
    //   "/models/example-texture.jpg"
    // );

    const texture = new THREE.Texture(designImageData);
    texture.needsUpdate = true;
    let tshirt1 = loadGlb("/models/tshirt_1.glb", texture, scene);
    let tshirt2 = loadGlb("/models/tshirt_2.glb", texture, scene);
    tshirt2.position.x = 5;
    let tshirt3 = loadGlb("/models/tshirt_3.glb", texture, scene);
    tshirt3.position.x = 10;
    // loadGlb("/models/tshirt_3.glb", texture, scene);

    // const geometry = new THREE.BoxGeometry();
    // const material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
    // const cube = new THREE.Mesh(geometry, material);
    // scene.add(cube);

    const light = new THREE.AmbientLight(0x333333); // soft white light
    scene.add(light);

    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.9);
    directionalLight.position.set(0, 5, 5);
    scene.add(directionalLight);
    const helper = new THREE.DirectionalLightHelper(directionalLight, 5);
    // scene.add(helper);

    // const spotLight = new THREE.SpotLight(0xffffff, 0.9);
    // spotLight.position.set(0, 5, 3);
    // spotLight.lookAt(0, 0, 0);
    // scene.add(spotLight);
    // const spotLightHelper = new THREE.SpotLightHelper(spotLight, 5);
    // scene.add(spotLightHelper);

    camera.position.z = 2;

    function animate() {
      requestAnimationFrame(animate);

      // controls.update();
      renderer.render(scene, camera);
    }
    animate();
  });

  function loadGlb(glbFile, texture, scene) {
    const group = new THREE.Group();
    scene.add(group);
    const loader = new GLTFLoader();
    let tshirtMesh, kapstokMesh;
    loader.load(glbFile, function (gltf) {
      gltf.scene.rotation.y = Math.PI / 2;
      group.add(gltf.scene);

      tshirtMesh = gltf.scene.getObjectByName("Tshirt");
      if (!tshirtMesh) {
        console.log(gltf.scene);
        throw new Error(`Could not find t-shirt mesh in scene`);
      }
      const tshirtMaterial = new THREE.MeshStandardMaterial({
        map: texture,
        side: THREE.DoubleSide,
      });
      tshirtMesh.material = tshirtMaterial;
      // tshirtMesh.material.map = texture;

      kapstokMesh = gltf.scene.getObjectByName("Plastic_Clothes_Hanger");
      animate();
    });

    function animate() {
      requestAnimationFrame(animate);
      tshirtMesh.rotation.y += 0.01;
      kapstokMesh.rotation.y += 0.01;
    }
    return group;
  }

  function selectTshirt(index) {
    index -= 1;
    //camera.position.x = index * 5;
    gsap.to(camera.position, { x: index * 5, duration: 1 });
  }
</script>

<div />
<p>This is your preview</p>
<div class="color-buttons">
  <button on:click={() => selectTshirt(1)}
    ><img src="/icons/color-black.png" alt="Black" /></button
  >
  <button on:click={() => selectTshirt(2)}
    ><img src="/icons/color-black.png" alt="Black" /></button
  >
  <button on:click={() => selectTshirt(3)}
    ><img src="/icons/color-black.png" alt="Black" /></button
  >
</div>

<canvas bind:this={canvas} id="preview" width="800" height="800" />
<div><button on:click={goToCheckout}> Buy</button></div>

<style>
  p {
    color: #020202;
    font-size: 2, 5em;
    font-weight: 100;
  }

  canvas {
    background-color: #e0e0e0;
  }

  .color-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
  }
  .color-buttons button {
    border: none;
    background: none;
  }
</style>
